import React, { useState, useEffect } from 'react';
import { sections } from './Dashboard';
import { Link, useLocation } from 'react-router-dom';
import Admin from './Admin';
import '../style/Header.scss';

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    // Փոխում ենք header-ի ոճը սքրոլ անելիս
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Փակում ենք մենյուն, երբ էջը փոխվում է
    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    return (
        <header className={`${isScrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
            <div className="header-container">
                <Link to="/" className="logo">
                    <img src="/arda.png" alt="Arda Logo" />
                </Link>

                {/* Desktop Navigation */}
                <nav className="desktop-nav">
                    <ul>
                        {sections.map((elem) => (
                            <li key={elem.id}>
                                <Link to={`/${elem.id}`} className={location.pathname === `/${elem.id}` ? 'active' : ''}>
                                    {elem.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="header-actions">
                    <Admin />

                    {/* Burger Icon */}
                    <div className={`burger-menu ${isMenuOpen ? 'open' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
                </div>
            </div>

            {/* Mobile Side Menu Overlay */}
            <div className={`mobile-overlay ${isMenuOpen ? 'show' : ''}`} onClick={() => setIsMenuOpen(false)}></div>

            <nav className={`mobile-nav ${isMenuOpen ? 'active' : ''}`}>
                <div className="mobile-nav-header">
                    <img src="/arda.png" alt="Logo" />
                    <button className="close-btn" onClick={() => setIsMenuOpen(false)}>&times;</button>
                </div>
                <ul>
                    {sections.map((elem) => (
                        <li key={elem.id}>
                            <Link to={`/${elem.id}`}>{elem.title}</Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    );
}